import React, {FC} from 'react'

interface ToolbarButtonProps {
    disabled?: boolean
    active: boolean
    icon: FC
    label: string
    title: string
    onClick: () => void
}

export const ToolbarButton: FC<ToolbarButtonProps> = ({
    disabled,
    active,
    icon: Icon,
    label,
    title,
    onClick,
}) => (
    <button
        className={`canvas-toolbar__button ${active ? 'canvas-toolbar__button--active' : ''}`}
        disabled={disabled}
        onClick={onClick}
        aria-label={label}
        aria-pressed={active}
        title={title}
    >
        <Icon />
    </button>
)
